<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="isNewScreenSize">
                        Tworzenie nowego wymiaru
                    </template>
                    <template v-else>
                        Edycja wymiaru - <strong>{{ screenSizeData.sizeA }} x {{ screenSizeData.sizeB }}</strong>
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="screenSize.sizeA"
                                label="Wymiar A"
                                :error-messages="screenSizeSizeAErrors"
                                dense
                                outlined
                                required
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="screenSize.sizeB"
                                label="Wymiar B"
                                :error-messages="screenSizeSizeBErrors"
                                dense
                                outlined
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="saveScreenSize()"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'
import { required, maxLength } from 'vuelidate/lib/validators'
import { twoDigitsAfterDecimal } from '@/utils/customValidators'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'OutdoorsLocalizationScreenSizeDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        screenSizeData: {
            type: Object,
            default: null
        },
        outdoorsLocalizationScreenData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            screenSize: {
                sizeA: null,
                sizeB: null
            },
            actionLoading: false,
            outdoorsLocalizationScreen: {}
        }
    },
    validations: {
        screenSize: {
            sizeA: {
                required,
                maxLength: maxLength(13),
                twoDigitsAfterDecimal
            },
            sizeB: {
                required,
                maxLength: maxLength(13),
                twoDigitsAfterDecimal
            }
        }
    },
    computed: {
        isNewScreenSize() {
            return isEmpty(this.screenSizeData)
        },
        screenSizeSizeAErrors() {
            const errors = []

            if (!this.$v.screenSize.sizeA.$dirty) return errors

            if (!this.$v.screenSize.sizeA.required) {
                errors.push('Pole jest wymagane.')
            }
            if (!this.$v.screenSize.sizeA.twoDigitsAfterDecimal || !this.$v.screenSize.sizeA.maxLength) {
                errors.push('Pole może zawierać maksymalnie 10 cyfr z dwoma miejscami po przecinku.')
            }

            return errors
        },
        screenSizeSizeBErrors() {
            const errors = []

            if (!this.$v.screenSize.sizeB.$dirty) return errors

            if (!this.$v.screenSize.sizeB.required) {
                errors.push('Pole jest wymagane.')
            }
            if (!this.$v.screenSize.sizeB.twoDigitsAfterDecimal || !this.$v.screenSize.sizeB.maxLength) {
                errors.push('Pole może zawierać maksymalnie 10 cyfr z dwoma miejscami po przecinku.')
            }

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.screenSize = JSON.parse(JSON.stringify(this.screenSizeData))
            }
            this.outdoorsLocalizationScreen = JSON.parse(JSON.stringify(this.outdoorsLocalizationScreenData))
        }
    },
    methods: {
        saveScreenSize() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            this.actionLoading = true

            let action = null

            this.isNewScreenGroup ? action = 'createLocalizationScreenSize' : action = 'updateLocalizationScreenSize'

            this.$store.dispatch(`outdoors/outdoorsSettings/${action}`, this.screenSize)
                .then(response => {
                    this.outdoorsLocalizationScreen.localizationScreenSize = response.data
                    this.outdoorsLocalizationScreen.localizationScreenSizeId = response.data.id
                    this.$emit('update-screen', this.outdoorsLocalizationScreen)
                    this.$emit('get-outdoors-localization-screen-sizes')
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                    this.onClose()
                })
        },
        onClose() {
            this.actionLoading = false

            setTimeout(() => {
                this.screenSize.sizeA = null
                this.screenSize.sizeB = null
                this.$v.$reset()
            }, 500)
            this.$emit('on-close')
        }
    }
}
</script>
